<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-cambio-estado"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">{{ opcionModal }}</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" v-if="tipoCambio == 1">
              <label for="tipo">Tipo</label>
              <select
                class="form-control form-control-sm"
                v-model="form.estado"
                :class="$v.form.estado.$invalid ? 'is-invalid' : 'is-valid'"
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="estados in listasForms.estados"
                  :key="estados.numeracion"
                  :value="estados.numeracion"
                >
                  {{ estados.descripcion }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="fecha">Fecha</label>
              <input
                type="date"
                class="form-control form-control-sm"
                id="fecha"
                v-model="form.fecha"
                :class="$v.form.fecha.$invalid ? 'is-invalid' : 'is-valid'"
              />
              <div class="error" v-if="!$v.form.fecha.required">
                Ingrese una Fecha
              </div>
            </div>
            <div class="form-group">
              <label for="hora">Hora</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="hora"
                v-model="form.hora"
                :class="$v.form.hora.$invalid ? 'is-invalid' : 'is-valid'"
                v-mask="{
                  mask: '99:99',
                  hourFormat: '24',
                }"
              />
              <div class="error" v-if="!$v.form.hora.required">
                Ingrese una Hora
              </div>
            </div>
            <div class="form-group" v-if="tipoCambio == 1">
              <label for="justificacion">Justificacion</label>
              <textarea
                v-model="form.justificacion"
                :class="
                  $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                "
                cols="30"
                rows="5"
                class="form-control form-control-sm"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, helpers, minLength } from "vuelidate/lib/validators";
import moment from "moment";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/
);
export default {
  name: "GestionHidrocarburosEstado",
  components: {},
  data() {
    return {
      form: {
        estado: null,
        fecha: null,
        hora: null,
        entidad_id: null,
        entidad_type: null,
        justificacion: null,
      },
      tipoCambio: null,
      listasForms: {
        estados: [],
      },
      opcionModal: null,
    };
  },
  validations() {
    let status = {};
    let jt = {};
    if (this.tipoCambio == 1) {
      status = {
        required,
      };
      jt = {
        required,
        minLength: minLength(10),
      };
    } else {
      status = {
        required: false,
      };
      jt = {
        required: false,
      };
    }

    return {
      form: {
        estado: status,
        justificacion: jt,
        fecha: {
          required,
        },
        hora: {
          required,
          timeFormat,
        },
      },
    };
  },
  methods: {
    save() {
      if (!this.$v.form.$invalid) {
        axios({
          method: "POST",
          url: "api/admin/centralTrafico/cambiarEstado",
          data: this.form,
        }).then(() => {
          this.$parent.cargarDatos();
          this.$refs.closeModal1.click();
          this.$swal({
            icon: "success",
            title: "Se realizo el cambio exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      }
    },

    llenarModal(data, opcionModal, tipo) {
      this.opcionModal = opcionModal;
      this.form.entidad_type = data.tipo;
      this.form.entidad_id = data.id;
      this.form.fecha = moment().format("YYYY-MM-DD");
      this.form.hora = moment().format("HH:mm:ss");
      this.form.justificacion = null;
      this.form.estado = null;
      this.tipoCambio = tipo;
      if (tipo == 1) {
        if (data.tipo == "Viaje") {
          this.getEstadosAnulacionViaje();
        } else if (data.tipo == "Postulacion") {
          this.getEstadosAnulacionPostulacion();
        }
      }
    },

    getEstadosAnulacionViaje() {
      axios.get("/api/lista/68").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getEstadosAnulacionPostulacion() {
      axios.get("/api/lista/69").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
  },
};
</script>
